import { gql } from '@apollo/client';

export const postAdhesionComerciosPreSolicitud = gql`
mutation AdhesionComerciosPreSolicitudApiRQ{
    AdhesionComerciosPreSolicitudApiRQ(input: $input)  
        @rest(type: "AdhesionComerciosPreSolicitudApiRS", path: "/api/gateway/formulariosComercios/presolicitud", method: "PUT"){
            resultado
            mensaje
            nroSolicitud
          
        }
}
`

